import { createFileRoute } from "@tanstack/react-router"
import { ActivitiesPage } from "./-components/ActivitiesPage"
import { SearchValue } from "../../-components/infinit-scrolling-table/extended-infinit-scrolling-table"

export interface Search extends SearchValue<"/api/Activity/GetActivityTable"> {
  view: "table" | "list"
}

export const Route = createFileRoute("/app/art/activities/")({
  component: ActivitiesPage,
  validateSearch: (search: Search) => search,
})
